import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;


export class ZIDXAccountCrawlQueue implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlQueueContainer";
    }
    render(){
        // console.log("Crawl Queue");

        $(".zidxAccountCrawlQueueContainer .retryFailedButton", this.zidx.peakidxShadowRoot).on("click", function(this:HTMLElement, e){
            e.preventDefault();
            if(window.confirm("Are you sure you want to retry failed URLs?")) {
                $.get((this as HTMLAnchorElement).href, {}, function (data) {
                    if (data.success) {
                        // alert("Retrying failed URLs");
                    } else {
                        alert("Failed to retry URLs: " + data.errorMessage);
                    }
                });
            }
        });
        $(".zidxAccountCrawlQueueContainer .clearCompletedButton", this.zidx.peakidxShadowRoot).on("click", function(this:HTMLElement, e){
            e.preventDefault();
            if(window.confirm("Are you sure you want to clear completed URLs?")) {
                $.get((this as HTMLAnchorElement).href, {}, function (data) {
                    if (data.success) {
                        alert("Crawl queue cleared");
                    } else {
                        alert("Failed to clear crawl queue: " + data.errorMessage);
                    }
                });
            }
        });
    }
}
